import type { FC } from "react";
import { RichText } from "@components/cms/rich-text-renderer/RichText";
import type { BoxProps } from "@ecco/ui/box";
import { Box } from "@ecco/ui/box";
import type { Document } from "@contentful/rich-text-types";
import { isEmpty } from "lodash-es";

export interface IAuthInvitationProps extends BoxProps {
    text: Document;
}

const AuthInvitation: FC<IAuthInvitationProps> = ({ text, ...rest }) => {
    return (
        <>
            {!isEmpty(text) && (
                <Box
                    backgroundColor="white"
                    w="100%"
                    fontSize={["mobileBodyTextNormal", "desktopBodyTextSmall"]}
                    fontWeight={"semibold"}
                    m={0}
                    sx={{
                        "& p": {
                            mb: 0,
                        },
                    }}
                    {...rest}
                >
                    <RichText data={text} />
                </Box>
            )}
        </>
    );
};

export default AuthInvitation;
